export default function initAccordion() {
    const toggles = document.querySelectorAll('.accordion__toggle');

    toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
            const item = toggle.closest('.accordion__item');
            const panel = item ? item.querySelector('.accordion__container') : null;
            if (!item || !panel) return;

            const expanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', String(!expanded));
            item.setAttribute('aria-expanded', String(!expanded));

            if (!expanded) {
                panel.style.maxHeight = panel.scrollHeight + 'px';
            } else {
                panel.style.maxHeight = '0px';
            }
        });
    });
}
